<template>
  <div class="float-right">
    <b-modal
        ref="edit-modal"
        :title="$t('modal.segment.add_new_segment')"
        size="xl">
      <div class="w-100 d-flex justify-content-center">
        <div v-if="step === 1" class="w-100 d-flex flex-column align-items-center justify-content-center">
          <div class="d-flex justify-content-center align-items-center mb-5">
            <h5 class="text-primary mr-2">{{$t('btn.segment.add_new_rule')}}</h5>
            <b-form-select
                v-model="rule"
                :options="options.ruleType">
            </b-form-select>
            <b-button @click="setRule({ruleId: null, methodPost: true})" type="button" variant="success" class="w-25 ml-2">{{$t('btn.segment.add_new_rule')}}</b-button>
          </div>

          <div ref="rulesContainer" class="w-100"></div>
        </div>

        <div v-if="step === 2" class="w-100 d-flex align-items-center justify-content-center">
          <h5 class="text-primary mr-3">{{$t('btn.segment.choose_segment_name')}}</h5>
          <b-form-input v-model="segment.name"></b-form-input>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <div class="buttons float-right">
            <b-button type="button" variant="secondary" class="mr-2"  @click="hideModal">{{$t('btn.cancel')}}</b-button>
            <b-button v-if="step === 1" variant="primary" @click="setStep(2)">{{$t('btn.segment.next_step')}}</b-button>
            <b-button v-if="step === 2" variant="primary" @click="saveSegmentName" :disabled="!segment.name">{{$t('btn.segment.next_step')}}</b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import GenderRule from "./rules/GenderRule";
import Vue from 'vue';
import { mapState } from 'vuex';
import {requiredIf} from "vuelidate/lib/validators";
import {countryRule, userSegment} from "../../../common/constants/userSegment";
import {genderRule} from "../../../common/constants/userSegment";
import CountryRule from "./rules/CountryRule";

export default {
  components: {

  },
  props: {
    item: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      ruleForms: {
        gender: {
          value: []
        },
        country: {
          value: [],
          operation: ''
        },
      },
      step: 1,
      rule: '',
      chosenSegmentType: '',
      rules: [],
      segment: {
        name: '',
        isStatic: null,
        rules: {
          rules: [

          ]
        }
      },
      options: {
        ruleType: [
          { value: null, text: this.$t('btn.segment.set_rule_placeholder'), disabled: true}
        ]
      }
    };
  },
  computed: {
    ...mapState({
      editedRule: (state) => state.userSegment.editedRule
    })
  },
  validations: {
    ruleForms: {
      gender: {
        value: { required: requiredIf(function () {
            return this.rules.includes(userSegment.gender);
          })
        }
      },
      country: {
        value: { required: requiredIf(function () {
            return this.rules.includes(userSegment.country);
          })
        },
        operation: { required: requiredIf(function () {
            return this.rules.includes(userSegment.country);
          })
        }
      }
    }
  },
  mounted() {
    this.segment.name = this.item.name;

    this.$store.dispatch('userSegment/getRuleTypes').then(resp => {
      resp.data.forEach(rule => {
        this.options.ruleType.push({
            value: rule,
            text: this.$t(`btn.segment.segment_type.${rule}`)
          }
        );
      });
    });

    // GENDER RULE
    this.$on('selectedGender', (e) => {
      this.$v.ruleForms.gender.value.$touch();
      this.setGenderRule(e);
    });

    this.$on('removeGenderRule', (e) => {
      this.removeComponent(e);
    });

    // COUNTRY RULE
    this.$on('selectedCountry', (e) => {
      this.$v.ruleForms.country[e.type].$touch();

      this.setCountryRule(e);
    });

    this.$on('removeCountryRule', (e) => {
      this.removeComponent(e);
    });

    this.$on('deleteSegmentRule', (e) => {
      this.removeComponent(e);
    });

    this.$on('editRule', (e) => {
      if(e.methodPost) {
        this.updateGenderRule(e.type);
        return;
      }

      this.editRule(e);
    });

    this.$store.dispatch('userSegment/getSegmentRules', this.item.id).then(resp => {
      resp.forEach(rule => {
        if(rule.type === userSegment.gender) {
          this.ruleForms.gender.value = rule.allowedGenders;
          this.rule = userSegment.gender;
          this.setRule({ ruleId: rule.id, methodPost: false });
        }

        if(rule.type === userSegment.country) {
          this.ruleForms.country.value = rule.countries;
          this.ruleForms.country.operation = rule.operation;
          this.rule = userSegment.country;
          this.setRule({ ruleId: rule.id, methodPost: false });
        }
      })
    });
  },
  methods: {
    saveSegmentName() {
      const payload = {
        id: this.item.id,
        name: this.segment.name
      }

      this.$store.dispatch('userSegment/changeSegmentName', payload).then(() => {
        this.hideModal();
        this.$parent.$emit('refreshGrid');
      });
    },
    updateGenderRule(type) {
      if(!this.$v.ruleForms[type.toLowerCase()].$invalid) {
        let payloadData;

        const value = this.ruleForms[type.toLowerCase()].value.map(rule => {
          return rule.value;
        });

        switch(type) {
          case userSegment.gender:
            payloadData = { allowedGenders: value, type: type }
            break;
          case userSegment.country:
            payloadData = { countries: value, operation: this.ruleForms.country.operation, type: type }
        }

        const payload = {
          id: this.item.id,
          data: {
            rules:  [
              payloadData
            ]
          }
        }

        this.$store.dispatch('userSegment/updateSegmentRules', payload).then(() => {
          const data = {
            key: userSegment[type.toLowerCase()],
            value: false
          }

          this.$store.commit('userSegment/setEditedRule', data);
        });
      }
    },
    editRule(params) {
      if(!this.$v.ruleForms[params.type.toLowerCase()].$invalid) {
        let payloadData;

        const value = this.ruleForms[params.type.toLowerCase()].value.map(rule => {
          return rule.value;
        });

        switch(params.type) {
          case userSegment.gender:
            payloadData = { allowedGenders: value }
            break;
          case userSegment.country:
            payloadData = { countries: value, operation: this.ruleForms.country.operation }
        }

        const payload = {
          id: params.ruleId,
          type: params.type,
          data: payloadData
        }

        this.$store.dispatch('userSegment/editRule', payload).then(() => {
          const data = {
            key: userSegment[params.type.toLowerCase()],
            value: false
          }

          this.$store.commit('userSegment/setEditedRule', data);
        });
      }
    },
    deleteSegmentRule(ruleId) {
      this.$store.dispatch('userSegment/deleteSegmentRule', ruleId).then(() => {

      });
    },
    removeComponent(data) {
      data.component.$destroy();
      this.$refs.rulesContainer.removeChild(data.component.$el);

      this.rules = this.rules.filter(rule => {
        return rule !== data.rule;
      });

      this.segment.rules.rules = this.segment.rules.rules.filter(rule => {
        return rule.type !== data.rule;
      });

      if(data.ruleId) {
        this.$store.dispatch('userSegment/deleteSegmentRule', data.ruleId);
      }
    },
    setRule(paramsObject) {
      let ComponentClass;
      let instance;

      switch(this.rule) {
        case userSegment.gender:
          ComponentClass = Vue.extend(GenderRule)

          instance = new ComponentClass({
            parent: this,
            propsData: {
              v: this.$v.ruleForms.gender,
              genderForm: this.ruleForms.gender,
              isEditType: true,
              ruleId: paramsObject.ruleId,
              methodPost: paramsObject.methodPost
            }
          })
          break;

        case userSegment.country:
          ComponentClass = Vue.extend(CountryRule)

          instance = new ComponentClass({
            parent: this,
            propsData: {
              v: this.$v.ruleForms.country,
              countryForm: this.ruleForms.country,
              isEditType: true,
              ruleId: paramsObject.ruleId,
              methodPost: paramsObject.methodPost
            }
          });
      }

      if(!this.rules.includes(this.rule)) {
        this.rules.push(this.rule);

        if(this.rule === userSegment.gender) {
          this.segment.rules.rules.push(
              genderRule
          );
        }

        if(this.rule === userSegment.country) {
          this.segment.rules.rules.push(
              countryRule
          );
        }

        instance.$mount();

        this.$refs.rulesContainer.appendChild(instance.$el);
      }

      this.rule = '';
    },
    setGenderRule(e) {
      this.ruleForms.gender.value = e.val;
      this.segment.rules.rules.forEach(rule => {
        if(rule.type === userSegment.gender) {
          rule.allowedGenders = e.val.map(gender => {
            return gender.value;
          });
        }
      });
    },
    setCountryRule(e) {
      this.ruleForms.country.value = e.val;
      this.ruleForms.country.operation = e.operation;

      this.segment.rules.rules.forEach(rule => {
        if(rule.type === userSegment.country) {
          rule.countries = e.val.map(gender => {
            return gender.value;
          });

          rule.operation = e.operation;
        }
      });
    },
    setStep(value) {
      let isEdited;

      // for (const key in this.editedRule) {
      //   if(key) {
      //     isEdited = this.editedRule[key];
      //   }
      // }

      isEdited = Object.keys(this.editedRule).some(k => this.editedRule[k]);

      if(value === 1) {
        this.step = value;
        return;
      }

      if(!this.$v.$invalid && !isEdited) {
        this.step = 2;
      }

      if(this.$v.$invalid) {
        this.$v.$touch();
      }
    },
    setIsStatic(value) {
      this.segment.isStatic = value;
    },
    openModal() {
      this.$refs['edit-modal'].show()
    },
    hideModal() {
      this.$refs['edit-modal'].hide();
    }
  }
}
</script>
